import {create} from 'zustand';

export type LayerType = 'WMS' | 'Vector' | 'Overlay';

export interface BaseLayerConfig {
  id: string;
  name: string;
  visible: boolean;
  type: LayerType;
  zIndex?: number;
}

export interface WMSLayerConfig extends BaseLayerConfig {
  type: 'WMS';
  layerName: string;
  params?: Record<string, string>;
}

export interface VectorLayerConfig extends BaseLayerConfig {
  type: 'Vector';
  source: any;
  style?: any;
}

export interface OverlayLayerConfig extends BaseLayerConfig {
  type: 'Overlay';
  component: React.ReactNode;
}

type LayerConfig = WMSLayerConfig | VectorLayerConfig | OverlayLayerConfig;

interface LayerManagerStore {
  clusterLayerScale: number;
  layers: LayerConfig[];

  addLayer: (layer: LayerConfig) => void;
  removeLayer: (id: string) => void;
  toggleLayerVisibility: (id: string) => void;
  setLayerVisibility: (id: string, visible: boolean) => void;
  getLayerById: (id: string) => LayerConfig | undefined;
  setClusterLayerScale: (scale: number) => void;
}

export const useLayerManagerStore = create<LayerManagerStore>((set, get) => ({
  clusterLayerScale: 0,
  layers: [],

  addLayer: (layer) =>
    set((state) => ({
      layers: [...state.layers.filter((l) => l.id !== layer.id), layer]
    })),

  removeLayer: (id) =>
    set((state) => ({
      layers: state.layers.filter((layer) => layer.id !== id)
    })),

  toggleLayerVisibility: (id) =>
    set((state) => ({
      layers: state.layers.map((layer) => (layer.id === id ? {...layer, visible: !layer.visible} : layer))
    })),

  setLayerVisibility: (id, visible) =>
    set((state) => ({
      layers: state.layers.map((layer) => (layer.id === id ? {...layer, visible} : layer))
    })),

  getLayerById: (id) => get().layers.find((l) => l.id === id),

  setClusterLayerScale: (scale) => set({clusterLayerScale: scale})
}));
